import { render, staticRenderFns } from "./WidgetPrevious.vue?vue&type=template&id=04fec1c5&"
import script from "./WidgetPrevious.vue?vue&type=script&lang=ts&"
export * from "./WidgetPrevious.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports